import { z } from 'zod';

export const SubscriptionIntervalSchema = z.enum([ 'monthly', 'yearly' ]);
export type SubscriptionInterval = z.infer<typeof SubscriptionIntervalSchema>;
